import React from "react";
import LocaleProvider from "../LocaleProvider";
import MuiPickersProvider from "../MuiPickersProvider";
import SnackbarProvider from "../SnackbarProvider";
import ThemeProvider from "../ThemeProvider";
const UIProvider = ({ children, messages, debug, defaultLocale }) => {
    return (React.createElement(ThemeProvider, null,
        React.createElement(LocaleProvider, { messages: messages, debug: debug, defaultLocale: defaultLocale },
            React.createElement(MuiPickersProvider, null,
                React.createElement(SnackbarProvider, null, children)))));
};
UIProvider.defaultProps = {
    defaultLocale: "en",
};
export default UIProvider;
//# sourceMappingURL=index.js.map